import { useQuery } from '@tanstack/react-query';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';
import { IUserActivityTracking } from '../../../../interfaces/User.interfaces';
import { getUserActivityTracking } from '../../../../api/user/queries/getUserActivityTracking';
import { AxiosError } from 'axios';

export const useGetUserActivityTracking = (pageType?: 'TLP' | 'TDP') => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<IUserActivityTracking[], AxiosError>(['user_activity_tracking', pageType], getUserActivityTracking, {
    enabled: isUserLoggedIn,
  });
};
